import React, { useCallback } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import AppSnackbar from "../Common/Snackbar/AppSnackbar";
import { removeAlert } from "../../action/alert";

const mapAlertTypeToSeverity = (alertType) => {
  if (alertType === "danger") return "error";
  if (alertType === "show") return "info";
  if (["success", "error", "warning", "info"].includes(alertType)) {
    return alertType;
  }
  return "info";
};

const Alert = ({ alerts, removeAlert: removeAlertAction }) => {
  const active = alerts?.length ? alerts[alerts.length - 1] : null;

  const handleClose = useCallback(() => {
    if (active?.id != null) {
      removeAlertAction(active.id);
    }
  }, [active?.id, removeAlertAction]);

  if (!active) {
    return null;
  }

  return (
    <AppSnackbar
      open
      type={mapAlertTypeToSeverity(active.alertType)}
      message={active.msg ?? ""}
      autoHideDuration={3000}
      onClose={handleClose}
      sx={{ zIndex: (theme) => theme.zIndex.modal + 2000 }}
    />
  );
};

Alert.propTypes = {
  alerts: PropTypes.array,
  removeAlert: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  alerts: state.alert,
});

export default connect(mapStateToProps, { removeAlert })(Alert);
